export const introEvents = [
    { title: "Sign Up Date", img: "/images/svg/Checklist-1.svg", description: "Partnership begins" },
    { title: "Welcome Call", img: "/images/svg/Customer-2.svg", description: "Within 3 business days" }
];

export const timelineEvents = [
    { offset: 0, title: "Target Shoot Date", img: "/images/svg/Camera.svg", disclaimer: " * Within 30 days of welcome call" },
    { offset: 16, title: "Profile Creation", img: "/images/svg/Laptop.svg" },
    { offset: 21, title: "Client Review", img: "/images/svg/Customer-1.svg" },
    { offset: 26, title: "Edits Implemented", img: "/images/svg/Laptop.svg"  },
    { offset: 29, title: "Client Final Review", img: "/images/svg/Desktop.svg" },
    { offset: 31, title: "Client Launches", img: "/images/svg/Checklist-2.svg" },
];



//////////////////
// WEBPACK FOOTER
// ./src/ts/timeline_events.js
// module id = 302
// module chunks = 0